import searchDomains from "@/redux/slices/domains/thunks/searchDomains";
import bulkSearchDomains from "@/redux/slices/domains/thunks/bulkSearchDomains";
import customSearchDomains from "@/redux/slices/domains/thunks/customSearchDomains";

const thunks = [searchDomains, bulkSearchDomains, customSearchDomains];

export default thunks;
